export const hr = {
    LEFT: 'Lijevo: prelazak na prethodni dan.',
    RIGHT: 'Desno: prelazak na sljedeći dan.',
    DOWN: 'Dolje: idi na sljedeći redak.',
    UP: 'Gore: skoči na prethodnoj liniji.',
    PGUP: 'Gore: prelazak na prethodni mjesec.',
    PGDOWN: 'PgDown: idi na sljedeći mjesec.',
    HOME: 'Kuće: prijelaz na prethodnu godinu.',
    END: 'Kraj: premjestiti na sljedeću godinu.',
    ESC: 'Эку/danas/close (zatvori): zatvori kalendar. Upute',
    TITLE: 'Tipkovnica '
};
